import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebaseConnection';
import logo from './Logo_oficial_CCB.png';
import { AuthContext } from '../../contexts/auth';
import { FaAddressCard, FaTasks, FaCity } from 'react-icons/fa';
import { TbStarsFilled } from "react-icons/tb";
import { BsCalendar2MonthFill } from "react-icons/bs";
import { GiFamilyHouse } from "react-icons/gi";
import { CiLogout } from 'react-icons/ci';
import { GrDocumentTxt } from "react-icons/gr";
import './header.css';

export default function Header() {
  const { user, logout } = useContext(AuthContext);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    async function loadPermissions() {

      const storedUser = localStorage.getItem('@userLogado');
      if (!storedUser) {
        console.error('Usuário não encontrado no localStorage.');
        return;
      }

      const userData = JSON.parse(storedUser);
      const cargoId = userData?.cargo;

      if (!cargoId) {
        console.error('ID do cargo não encontrado no usuário.');
        return;
      }

      try {
        const cargoRef = doc(db, 'Cargo', cargoId);
        const cargoDoc = await getDoc(cargoRef);

        if (cargoDoc.exists()) {
          const cargoData = cargoDoc.data();

          setPermissions(cargoData.permissoes || []);
        } else {
          console.error('Documento do cargo não encontrado no Firestore.');
        }
      } catch (error) {
        console.error('Erro ao buscar permissões no Firestore:', error);
      }
    }

    loadPermissions();
  }, []);

  const hasPermission = (permission) => {
    return permissions.includes(permission);
  };

  return (
    <div className="sidebar">
      <img
        src={logo}
        alt="Logo"
        style={{
          width: '10rem',
          backgroundColor: 'white',
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'flex',
          marginTop: '0.5rem',
        }}
      />

      <section className='div_sidebar'>
      {hasPermission('home') && (
        <Link to="/home">
          <FaTasks className="icons_sidebar" size={24} />
          Compromissos
        </Link>
      )}

      <Link to="/calendario">
        <BsCalendar2MonthFill className="icons_sidebar" size={24} />
        Calendário
      </Link>

      {hasPermission('usuario_lista') && (
        <Link to="/user">
          <FaAddressCard className="icons_sidebar" size={24} />
          Usuários
        </Link>
      )}

      {hasPermission('igreja_lista') && (
        <Link to="/igreja">
          <GiFamilyHouse className="icons_sidebar" size={24} />
          Casas de Oração
        </Link>
      )}

      {hasPermission('cargo_lista') && (
        <Link to="/cargo">
          <TbStarsFilled className="icons_sidebar" size={24} />
          Cargos
        </Link>
      )}

      {hasPermission('cidade_lista') && (
        <Link to="/cidade">
          <FaCity className="icons_sidebar" size={24} />
          Cidade
        </Link>
      )}

      {hasPermission('relatorio_lista') && (
        <Link to="/relatorio">
          <GrDocumentTxt className="icons_sidebar" size={24} />
          Relatório
        </Link>
      )}

      <Link to="/" onClick={() => logout()}>
        <CiLogout className="icons_sidebar" size={24} />
        Sair
      </Link>
      </section>
    </div>
  );
}
